import { formatCurrencyToScaleTruncated } from '@/utilities/portfolio/formatValue';
import { format } from 'date-fns';

const totalDividend = formatCurrencyToScaleTruncated(412, 'USD');
const totalCompanies = 20;

interface Props {
  selectedTimestamp?: string;
}

const getFormattedMonth = (selectedTimestamp?: string) => {
  if (!selectedTimestamp) {
    return '';
  }
  const unixTimestamp = parseInt(selectedTimestamp, 10) * 1000;
  const date = new Date(unixTimestamp);
  return format(date, 'MMMM');
};

export const Tooltip = ({ selectedTimestamp }: Props) => {
  const currentMonth = getFormattedMonth(selectedTimestamp);

  return (
    <div className="grid gap-2 items-center grid-cols-[max-content_max-content_max-content] bg-p-black px-4 py-2">
      <div className="text-soft text-base font-strong">{currentMonth}</div>
      <div className="text-mega text-solid font-strong">{totalDividend}</div>
      <div className="text-tiny text-soft">From {totalCompanies} companies</div>
    </div>
  );
};
